<template>
  <div class="app-bar d-flex align-center">
    <OrganizationSelect />
    <v-menu v-model="open" offset-y left nudge-bottom="14" min-width="280" content-class="user-profile-menu-content">
      <template #activator="{ on, attrs }">
        <v-badge bottom color="success" overlap offset-x="12" offset-y="12" class="ms-4" dot>
          <div v-bind="attrs" v-on="on">
            <img v-if="isPepe" :src="icons.PepeRainbow" class="pepe-rainbow" />
            <avatar-icon v-else></avatar-icon>
          </div>
        </v-badge>
      </template>
      <v-list>
        <div class="pb-3 pt-2">
          <v-icon class="ms-4" size="40">
            {{ icons.mdiAccountCircle }}
          </v-icon>
          <div class="d-inline-flex flex-column justify-center ms-3" style="vertical-align: middle">
            <span class="text--primary font-weight-semibold mb-n1">
              <span v-html="$store.state.user.email"></span>
            </span>
            <small class="text--disabled text-capitalize">
              <span v-html="$store.state.user.firstName"></span> <span v-html="$store.state.user.lastName"></span>
            </small>
          </div>
        </div>
        <!-- Profile page -->
        <v-list-item :to="{ name: 'settings' }">
          <v-list-item-icon class="me-2">
            <v-icon size="22">
              {{ icons.mdiAccountOutline }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("profile.account_settings") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Onboarding -->
        <v-list-item v-on:click="showOnboarding" v-click-outside="onCloseGuide" :class="{ active: guideActive }">
          <v-list-item-icon class="me-2">
            <v-icon size="22">
              {{ icons.mdiFileMultipleOutline }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("custom.onboarding.show") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Guide -->
        <v-list-item @click="redirectToHelpCenter">
          <v-list-item-icon class="me-2">
            <v-icon size="22">
              {{ icons.mdiHelpBoxOutline }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("generic.help_center") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Logout -->
        <v-list-item @click="logoutHandler">
          <v-list-item-icon class="me-2">
            <v-icon size="22">
              {{ icons.mdiLogoutVariant }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("auth.signout") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
  import {
    mdiAccountOutline,
    mdiEmailOutline,
    mdiCheckboxMarkedOutline,
    mdiChatOutline,
    mdiCogOutline,
    mdiCurrencyUsd,
    mdiHelpCircleOutline,
    mdiLogoutVariant,
    mdiAccountCircle,
    mdiFileMultipleOutline,
    mdiHelpBoxOutline,
  } from "@mdi/js";

  import AvatarIcon from "@/components/icons/AvatarIcon";
  import PepeRainbow from "@/assets/images/pepe/pepe-rainbow.gif";

  import { mapActions } from "vuex";
  import OrganizationSelect from "./OrganizationSelect.vue";
  import router from "@/router";
  import { eventBus } from "@/event-bus";
  import { mixpanelWrapper } from "@/@core/libs/mixpanel";
  import useAppConfig from "@core/@app-config/useAppConfig";

  export default {
    components: { OrganizationSelect, AvatarIcon },
    mounted() {
      eventBus.$on("open-menu", () => {
        this.open = true;
        setTimeout(() => {
          this.guideActive = true;
        }, 0);
      });
    },
    setup() {
      const { isPepe } = useAppConfig();

      return {
        icons: {
          mdiAccountOutline,
          mdiEmailOutline,
          mdiCheckboxMarkedOutline,
          mdiChatOutline,
          mdiCogOutline,
          mdiCurrencyUsd,
          mdiHelpCircleOutline,
          mdiLogoutVariant,
          mdiAccountCircle,
          mdiFileMultipleOutline,
          mdiHelpBoxOutline,
          PepeRainbow,
        },
        isPepe,
      };
    },
    data() {
      return {
        open: false,
        guideActive: false,
      };
    },
    methods: {
      ...mapActions({
        logout: "auth/logout",
      }),
      async logoutHandler() {
        if (this.$route.meta.disableRedirect) {
          eventBus.$emit("open-exit-modal", undefined, true);
        } else {
          this.logout();
        }
      },
      showOnboarding() {
        if (this.$store.getters["getCurrentUser"].onboarded) {
          mixpanelWrapper.track("Onboarding Reopened", { previous_page: this.$store.getters["getPreviousRoute"] });
        }
        this.$store.commit("SET_USER_ONBOARDED", false);
        this.$admin.dataProvider.customHttpCall("PATCH", `users/${this.$store.getters["getCurrentUser"].id}`, {
          onboarded: false,
        });
        if (this.$route.name !== "dashboard") {
          router.push({ path: "/dashboard" });
        }
      },
      redirectToHelpCenter() {
        window.open("https://help.siterunner.com/help", "_blank");
      },
      onCloseGuide() {
        this.guideActive = false;
      },
    },
    beforeDestroy() {
      eventBus.$off("open-menu");
    },
  };
</script>

<style lang="scss" scoped>
  @import "../@core/preset/preset/functions.scss";
  .app-bar {
    padding: 8px 0;
  }
  .user-profile-menu-content {
    .v-list-item {
      min-height: 2.5rem !important;
    }
  }

  .pepe-rainbow {
    height: 40px;
    width: 40px;
  }

  ::v-deep {
    .v-list {
      .v-list-item.active {
        background-color: get-color("primary-20");
        .v-icon,
        .v-list-item__title {
          color: get-color("secondary-btn") !important;
        }
      }
    }
  }
</style>
